import ItemPlaceholder from './ItemPlaceholder';

export default ItemPlaceholder;
